import { Box, Container } from "src/mui";
// import type { SxProps } from "src/mui";
import { SxProps } from "@mui/material";
const Banner = ({
  children,
  imageSx,
  colorSx,
  containerSx,
  url,
  container = true,
}: {
  children: any;
  imageSx?: SxProps;
  colorSx?: SxProps;
  containerSx?: SxProps;
  url?: { md: string; xs: string } | string;
  container?: boolean;
}) => {
  let bgUrl: any = `url(/assets/img/banner-bg.webp)`;
  if (url) {
    if (typeof url === "object") {
      bgUrl = {
        md: `url(${url?.md})`,
        xs: `url(${url?.xs})`,
      };
    } else {
      bgUrl = `url(${url})`;
    }
  }
  return (
    <Box
      component="div"
      sx={{
        backgroundImage: bgUrl,
        backgroundSize: "cover",
        width: "100%",
        // Reserve vertical space to reduce CLS and help the LCP render earlier
        minHeight: { xs: 300, md: 420 },
        ...imageSx,
      }}
    >
      <Box
        sx={{
          backgroundImage: "linear-gradient(#073662d6, #07366280)",
          py: 8,
          width: "100%",
          height: "100%",
          mt: 3,
          ...colorSx,
        }}
      >
        {container ? (
          <Container maxWidth="lg" sx={{ ...containerSx }}>
            {children}
          </Container>
        ) : (
          children
        )}
      </Box>
    </Box>
  );
};

export default Banner;
